// extracted by mini-css-extract-plugin
export default {"cls1":"eAMwLgNBd5CWQeJNpGin","cls2":"op2GlqFGxI3GC35FZw6v eAMwLgNBd5CWQeJNpGin"};